import { render, staticRenderFns } from "./view-request.vue?vue&type=template&id=50a2f9b2&"
import script from "./view-request.vue?vue&type=script&lang=js&"
export * from "./view-request.vue?vue&type=script&lang=js&"
import style0 from "./view-request.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports